var render = function render(){var _vm=this,_c=_vm._self._c;return _c('menu-button',{attrs:{"menu-button-color":_vm.menuButtonColor},on:{"click":_vm.menuOpened}})
}
var staticRenderFns = []

export { render, staticRenderFns }